<template>
    <div v-if="form && model">
        <rkm-area no-margin-top title="filtros" type="fieldset">
            <rkm-form
                ref="RkmForm"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-date-picker
                            :end-validations="{ required: true }"
                            :range-inline="false"
                            :start-validations="{ required: true }"
                            end-label="Até"
                            range
                            start-label="Período de"
                            v-model="model.periodo"
                            @input="getMunicipios"
                            :validations="validations.data"
                        />
                    </rkm-col>
                    <rkm-col>
                        <rkm-form-select
                            show-default-option
                            default-option-text="TODOS"
                            :options="form.municipios"
                            label="Município"
                            text-field="nome"
                            value-field="id"
                            v-model="model.municipio"
                            @change="getDestinos"
                        />
                    </rkm-col>
                    <rkm-col>
                        <rkm-form-select
                            show-default-option
                            default-option-text="TODOS"
                            :options="form.destinos"
                            label="Destino"
                            text-field="descricao"
                            value-field="id"
                            v-model="model.destino"
                            @change="getHorarios"
                        />
                    </rkm-col>
                </rkm-row>
                    <rkm-row>

                    <rkm-col cols="4">
                        <rkm-form-select
                            show-default-option
                            default-option-text="TODOS"
                            :options="form.horarios"
                            text-field="horario"
                            value-field="horario"
                            label="Horário de Saída"
                            v-model="model.horario"
                            @change="getPacientes"
                        />
                    </rkm-col>
                    <rkm-col cols="4">
                        <rkm-form-select
                            show-default-option
                            default-option-text="TODOS"
                            :options="form.pacientes"
                            text-field="nome"
                            value-field="id"
                            label="Paciente"
                            v-model="model.paciente"
                        />
                    </rkm-col>
                    <rkm-col>
                        <rkm-button
                            color="primary"
                            :label="false"
                            @click="search"
                            >Buscar</rkm-button
                        >
                        <rkm-button :label="false" @click="reset">
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>
        <rkm-area no-margin-top title="Resultado">
            <template v-slot:trailing>
                <rkm-dropdown
                    class="mr-2"
                    color="primary"
                    cols="1"
                    menu-class="auto-scroll"
                    no-caret
                    small
                    title="Colunas"
                    v-rkm-tooltip.hover
                >
                    <template v-slot:button-content>
                        <rkm-icon icon="columns" />
                    </template>

                    <rkm-form-checkbox
                        @change="selectAll"
                        class="mx-2"
                        v-model="selectedAll"
                    >
                        Todas
                    </rkm-form-checkbox>

                    <rkm-form-checkbox-group
                        :options="optionalColumns"
                        class="mx-2"
                        stacked
                        text-field="label"
                        v-model="selectedCols"
                        value-field="key"
                    />
                </rkm-dropdown>

                <rkm-button
                    :disabled="items.length === 0"
                    @click="print"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    :disabled="items.length === 0"
                    @click="exportTo"
                    color="info"
                    small
                    title="Exportar"
                >
                    <rkm-icon icon="file-export" />
                </rkm-button>

                <rkm-button
                    :disabled="items.length === 0"
                    @click="printCompleto"
                    color="warning"
                    small
                    title="Imprimir com movimentações"
                >
                    <rkm-icon icon="print" />
                    <rkm-icon icon="list" />
                </rkm-button>
            </template>

            <rkm-table
                :fields="fields"
                :items="items"
                no-footer-sorting
                sort-by=""
            >
                <template v-slot:cell(actions)="row">
                    <rkm-button
                        :id="uniqueId('show-btn')"
                        @click="$refs.ModalMovimentacoes.open(row.item)"
                        color="primary"
                        small
                        title="Movimentações"
                    >
                        <rkm-icon icon="history" />
                    </rkm-button>
                </template>
            </rkm-table>
        </rkm-area>
        <ModalMovimentacoes ref="ModalMovimentacoes" />
    </div>
</template>

<script>
import { mapActions } from "vuex";

import { repository, error, data, object, stringCase, file } from "@/mixins";

import moment from "moment";


// Components.
import ModalMovimentacoes from './modal/Movimentacoes'

export default {
    components: { ModalMovimentacoes },
    computed: {
        validations() {
            return {
                data: {
                    required: true
                }
            }
        },
        optionalColumns() {
            return this.columns.filter(c => !(c.fixed || false))
        },
        fields() {
            return this.columns.filter(c => (c.fixed || false) || this.selectedCols.includes(c.key))
        },
        selectedAll() {
            return this.selectedCols.length == 10
        }
    },
    created() {
        this.repositories = {
            relatorioAgendadores: this.getConectaSusRepository("transportePaciente.relatorioAgendador"),
            impressao: this.getConectaSusRepository('impressao.transportePaciente'),
            exportacao: this.getConectaSusRepository('exportacao.transportePaciente'),
        };
        this.load();
    },
    data() {
        return {
            form: null,
            model: null,
            items: [],
            selectedCols: [
                'paciente',
                'prontuario',
                'idade',
                'destino',
                'municipio',
                'dataHoraSaida',
                'ponto',
                'usuario',
                'status',
                'horaAgendamento',
                'actions'
            ],
            columns: [
                {
                    key: "paciente",
                    label: "Paciente",
                    fixed: true,
                    sortable: true,
                },
                {
                    key: "prontuario",
                    label: "Prontuário",
                    sortable: true,
                },
                {
                    key: "idade",
                    label: "Idade",
                    sortable: true,
                },
                {
                    key: "destino",
                    label: "Destino",
                    sortable: true,
                },
                {
                    key: "municipio",
                    label: "Município",
                    sortable: true,
                },
                {
                    key: "dataHoraSaida",
                    label: "Data/Horário de Saída",
                    sortable: true,
                },
                {
                    key: "ponto",
                    label: "Ponto",
                    sortable: true,
                },
                {
                    key: "acompanhante",
                    label: "Acompanhante",
                    sortable: true,
                },
                {
                    key: "usuario",
                    label: "Nome do agendador",
                    fixed: true,
                    sortable: true,
                },
                {
                    key: "status",
                    label: "Status",
                    fixed: true,
                    sortable: true,
                },
                {
                    key: "horaAgendamento",
                    label: "Data/Hora do agendamento",
                    sortable: true,
                },
                {
                    key: "actions",
                    label: "Ações",
                },
            ]
        };
    },
    methods: {
        ...mapActions(["setLoading", "unsetLoading"]),
        load() {
            this.setLoading();
            this.repositories.relatorioAgendadores
                .index()
                .then(({ data }) => {
                    if (data.form) this.form = data.form;
                    if (data.model) this.model = data.model;
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading());
        },
        getMunicipios() {
            if(this.model.periodo.start && this.model.periodo.end) {
                this.setLoading()
                this.model.periodo.start = moment(this.model.periodo.start).format('Y-M-D')
                this.model.periodo.end = moment(this.model.periodo.end).format('Y-M-D')
                this.repositories.relatorioAgendadores.getMunicipios({
                    periodo: this.model.periodo,
                })
                    .then(({data}) => {
                        this.form.municipios = data
                        this.getDestinos()
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())

                this.getPacientes();
            }
        },
        getDestinos() {
            if(this.model.periodo.start && this.model.periodo.end) {
                this.setLoading()
                this.model.periodo.start = moment(this.model.periodo.start).format('Y-M-D')
                this.model.periodo.end = moment(this.model.periodo.end).format('Y-M-D')
                this.repositories.relatorioAgendadores.getDestinos({
                    periodo: this.model.periodo,
                    municipio: this.model.municipio,
                })
                    .then(({data}) => {
                        this.form.destinos = data
                        this.getHorarios()
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        getHorarios() {
            if(this.model.periodo.start && this.model.periodo.end) {
                this.setLoading()
                this.model.periodo.start = moment(this.model.periodo.start).format('Y-M-D')
                this.model.periodo.end = moment(this.model.periodo.end).format('Y-M-D')
                this.repositories.relatorioAgendadores.getHorarios({
                    periodo: this.model.periodo,
                    municipio: this.model.municipio,
                    destino: this.model.destino,
                })
                    .then(({data}) => {
                        this.form.horarios = data
                        this.getPacientes();
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        getPacientes() {
            if(this.model.periodo.start && this.model.periodo.end) {
                this.setLoading()
                this.model.periodo.start = moment(this.model.periodo.start).format('Y-M-D')
                this.model.periodo.end = moment(this.model.periodo.end).format('Y-M-D')
                this.repositories.relatorioAgendadores.getPacientes({
                    periodo: this.model.periodo,
                    municipio: this.model.municipio,
                    destino: this.model.destino,
                    horario: this.model.horario,
                })
                    .then(({data}) => {
                        this.form.pacientes = data;
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        search() {
            if(this.model.periodo.start && this.model.periodo.end) {
                this.setLoading();
                this.model.periodo.start = moment(this.model.periodo.start).format('Y-M-D')
                this.model.periodo.end = moment(this.model.periodo.end).format('Y-M-D')
                this.repositories.relatorioAgendadores
                    .list({
                        periodo: this.model.periodo,
                        municipio: this.model.municipio,
                        destino: this.model.destino,
                        horario: this.model.horario,
                        paciente: this.model.paciente,
                    })
                    .then(({ data }) => {
                        if (data)
                            this.items = data;
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading());
            }
        },
        reset() {
            this.model.municipio = null
            this.model.destino = null
            this.model.horario = null
            this.items = []
        },
        print() {
            this.setLoading()
            this.repositories.impressao.relatorioAgendador(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        printCompleto() {
            this.setLoading()
            this.repositories.impressao.relatorioAgendadorCompleto(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        exportTo() {
            this.setLoading()
            this.repositories.exportacao.relatorioAgendador(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        prepareDataWithColumns() {
            const data = this.prepareData();
            data.selectedCols = this.fields
                .filter(f => f.key !== "actions")
                .map(f => {
                    return {
                        key: this.camelToSnake(f.key),
                        label: f.label,
                        class: f.class
                    };
                });

            return data;
        },
        prepareData() {
            const data = this.clone(this.model)
            return this.camelObjectKeysToSnakeRecursive(data)

        },
        selectAll(selected) {
            this.selectedCols = selected ? this.columns.map(c => c.key) : []
        }
    },
    mixins: [repository, error, data, object, stringCase, file],
    watch: {
        'model.periodo': {
            deep: true,
            handler() {
                this.getMunicipios()
            },
        },
    },
};
</script>
